import { ALO_OMS_HOST } from 'src/scripts/utils/constants';
import { isEmpty } from 'lodash-es';
import {
  DeliveryAvailability,
  SddProductsStoreAvailability,
  SddProductAvailability,
  SddResponseError,
} from './sddTypes';
import { customerLocationState } from '../StoreLocator/customerLocationState';
import { setIsFetchingData } from './sddState';
import { getDestinationObject } from '../../utils';

export const checkSddAvailabilityByProducts = async (products: SddProductAvailability[]) => {
  const destination = getDestinationObject(null, customerLocationState.sddZip, 'US');
  if (!destination?.postal_code && isEmpty(customerLocationState.sddZip)) return { detail: 'Location is unknown' };
  setIsFetchingData(true);

  const requestBody = {
    rate: {
      destination: destination,
      items: products,
    },
  };
  const response = await fetch(`${ALO_OMS_HOST}/ias/api/v1/find-availability/delivery?source=product_availability`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    console.error(`HTTP error! status: ${response.status}`);
    setIsFetchingData(false);
    return { detail: response.status.toString() };
  }
  const data: SddProductsStoreAvailability | SddResponseError = await response.json();
  setIsFetchingData(false);
  return data;
};

export const checkSddAvailabilityByCartForSidebar = async (items: SddProductAvailability[]) => {
  const destination = getDestinationObject(null, customerLocationState.sddZip, 'US');
  if (!destination?.postal_code && isEmpty(customerLocationState.sddZip)) return { detail: 'Location is unknown' };
  setIsFetchingData(true);

  const requestBody = {
    rate: {
      destination,
      items: items,
    },
  };
  const response = await fetch(`${ALO_OMS_HOST}/ias/api/v1/find-availability/delivery?source=cart_availability`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    console.error(`HTTP error! status: ${response.status}`);
    setIsFetchingData(false);
    return { detail: response.status.toString() };
  }
  const data: DeliveryAvailability | SddResponseError = await response.json();
  setIsFetchingData(false);
  if (Array.isArray(data)) {
    return data[0];
  }
  return data;
};

export const extractSddDataFromProductAvailabilityData = (productAvailabilityData: SddProductsStoreAvailability) => {
  let shippingInfo: DeliveryAvailability | null = null;
  if ('availabilityByProducts' in productAvailabilityData) {
    const deliveryFulfillmentNode = productAvailabilityData.availabilityByProducts[0]?.availabilityByFulfillmentTypes.find(
      (type) => type.fulfillmentType.toLowerCase() === 'delivery'
    );
    shippingInfo = deliveryFulfillmentNode?.availabilityDetails[0]?.availabilityByLocations?.[0] || null;
  }
  return shippingInfo;
};

export const formatCutoffTime = (time: string) => {
  const trimmed = time.trim();
  if (trimmed.includes(':')) return trimmed;
  return trimmed.replace(/(\d+)\s*(AM|PM)/i, '$1:00 $2');
};

export function getSddTileProps(option: SddShippingOption, hasLuxuryTag: boolean) {
  let price = option.price;
  let tileText = option.shippingDays;
  let title = option.title;
  const shippingCopy = window.getSiteSettings().pdpLuxuryShippingReturnCopy;
  if (hasLuxuryTag && option.service.toLowerCase() === 'expedited') {
    price = shippingCopy.pdpLuxuryShippingPrice ?? price;
    tileText = shippingCopy.pdpLuxuryShippingDays ?? tileText;
    title = shippingCopy.pdpLuxuryShippingTitle ?? title;
  }
  return { price, tileText, title };
}
